<script setup lang="ts">
import type { CarouselProps } from '#ui/types';
import lodashOmit from 'lodash-es/omit';

export interface StoryblokUiCarouselProps {
    blok: StoryblokUiCarousel;
}

// PROPS
const { blok } = defineProps<StoryblokUiCarouselProps>();

// DATA
const carouselProps = computed<Omit<CarouselProps, 'items'>>(() =>
    lodashOmit(storyblokOmitEmptyValues<StoryblokUiCarousel>(blok), ['_uid', 'items', 'itemsPerPage'])
);
const ui = useStoryblokCarouselCarouselUi(() => blok.itemsPerPage ?? '1');
</script>

<template>
    <UCarousel v-slot="{ item }" v-editable="blok" v-bind="carouselProps" :items="blok.items ?? []" :ui="ui">
        <StoryblokComponent :blok="item" />
    </UCarousel>
</template>
